import type { ApiWhere, ContractFilterObject } from '@eliadmin/eli-api-contract/store';
import { storeApiResources } from '@eliadmin/eli-api-contract/store';
import type { TourFilter } from '../stores/tours-store';

type TourWhere = ApiWhere<typeof storeApiResources.storefrontTravelAgencyTours>;

/** Preserve supported selections while serializing exclusively through the public contract. */
export function buildToursListOptions(filter: TourFilter) {
  // These old controls have no corresponding tour data. Never substitute unrelated attribute IDs.
  if (filter.food || filter.rating !== undefined || filter.locations?.length || filter.equipment?.length) {
    throw new Error('Unsupported legacy tour selection. Clear the filters to continue.');
  }

  const where: TourWhere = {};
  const filters: ContractFilterObject = {};
  if (filter.price_from !== undefined) filters.priceFrom = { id: 'priceFrom', value: filter.price_from };
  if (filter.price_to !== undefined) filters.priceTo = { id: 'priceTo', value: filter.price_to };
  if (filter.nights_count !== undefined) {
    where.tourDatesNightsCount = { greater_than_equal: filter.nights_count };
  }
  if (filter.date_start) where.tourDatesDateStart = { greater_than_equal: filter.date_start };
  if (filter.date_end) where.tourDatesDateStop = { less_than_equal: filter.date_end };
  if (filter.values?.length) where.values = { in: filter.values };
  if (filter.categories?.length) where.categories = { in: filter.categories };
  if (filter.tags?.length) where.tags = { in: filter.tags };
  if (filter.tour) where.id = { equals: filter.tour };

  return { where: Object.keys(where).length ? where : undefined, filters };
}
